import { isObject } from '@fabric-app/utils/guards';

const resourceDetailsQueryKeys = {
  pagePreview: (resourceId) => [
    "resource-page-preview",
    resourceId
  ],
  spotifyPreview: (url) => [
    "resource-page-preview",
    url
  ],
  pageMarkdown: (resource) => [
    "resource-page-markdown",
    resource?.data.webpage?.reader?.url || null
  ],
  favicon: (url, size) => [
    "resource-favicon",
    url,
    size
  ],
  storedFileDetails: (fdoc) => [
    "resource-stored-file-details",
    fdoc?.id
  ],
  imageDetails: (fdoc) => [
    "resource-image-details",
    fdoc?.id
  ],
  ancestors: (resourceId) => [
    "resource-ancestors",
    resourceId || null
  ],
  notepadState: (resourceDetail) => [
    "resource-notepad-state",
    resourceDetail?.id || null
  ],
  notepadSync: (resourceDetail) => [
    "resource-notepad-sync",
    resourceDetail?.id || null
  ],
  linkPreview: (url) => [
    "resource-detail-link-preview",
    url
  ],
  fileContent: (resourceFileUrl) => [
    "resource-file-content",
    resourceFileUrl
  ],
  assets: (resourceId) => [
    "resource-assets",
    resourceId || null
  ],
  transcript: (resource) => {
    const transcriptPath = resource && "transcript" in resource.data && isObject(resource.data.transcript) && "url" in resource.data.transcript ? resource.data.transcript.url : null;
    return transcriptPath ? [
      "resource-transcript",
      resource?.id,
      transcriptPath
    ] : [];
  }
};

export { resourceDetailsQueryKeys };
//# sourceMappingURL=resourceDetailsQueryKeys.js.map
